// extracted by mini-css-extract-plugin
export default {"productsListTitleWrapper":"EditOrderItemsList_productsListTitleWrapper__+sDPH","name":"EditOrderItemsList_name__8dTv7","listWrapper":"EditOrderItemsList_listWrapper__ddW4I"};